module.exports = "<span class=tooltip-container ng-if=::tooltipIconCtrl.hint><img class=tooltip-icon-image ng-src={{::tooltipIconCtrl.icon}} /><div class=hint ng-bind-html=::tooltipIconCtrl.hint></div></span>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common/widgets/tooltip-icon/tooltip-icon.html
// module id = 807
// module chunks = 0